import {viewingInstant} from '../../../shared/viewingTime.js';
import {viewingTimeZone} from '../../../shared/viewingPolicy.js';
export const propertyActionTitles = { viewing: "Request a viewing", offer: "Make an offer", rental: "Apply to rent", documents: "Request documents" };

export function buildPropertyAction(kind, listing, fields, now = Date.now()) {
  const listingId = String(listing?._id || listing?.id || "");
  if (!listingId) throw new Error("This property is unavailable.");
  const note = String(fields.note || "").trim();
  if (kind === "viewing") {
    let startsAt,endsAt;const timeZone=fields.timeZone||viewingTimeZone();
    try{startsAt=viewingInstant(fields.startsAt,timeZone);endsAt=viewingInstant(fields.endsAt,timeZone);}catch{throw new Error("Choose valid start and end times in the displayed timezone.");}
    if (!Number.isFinite(startsAt) || startsAt <= now) throw new Error("Choose a viewing time in the future.");
    if(!Number.isSafeInteger(endsAt)||endsAt<=startsAt)throw new Error("Choose valid start and end times in the displayed timezone.");
    return { listingId, appointmentType: "viewing", startsAt, endsAt, timeZone, note };
  }
  if (kind === "offer") {
    const amountOMR = Number(fields.amountOMR);
    if (!Number.isFinite(amountOMR) || amountOMR <= 0) throw new Error("Enter an offer greater than zero.");
    if (!["cash", "mortgage"].includes(fields.financingType)) throw new Error("Choose a financing type.");
    let expiresAt=null;try{if(fields.offerExpiry)expiresAt=viewingInstant(fields.offerExpiry,Intl.DateTimeFormat().resolvedOptions().timeZone);}catch{throw new Error("Choose a valid future offer expiry.");}if(expiresAt!==null&&expiresAt<=now)throw new Error("Choose a valid future offer expiry.");
    if(Math.abs(amountOMR*1000-Math.round(amountOMR*1000))>.00001)throw new Error("Use at most three decimal places for an OMR offer.");
    return { listingId, amountOMR, financingType: fields.financingType, message: note, expiresAt };
  }
  if (kind === "rental") {
    const moveInDate = new Date(`${fields.moveInDate}T00:00:00Z`).getTime();
    const today = new Date(now); today.setUTCHours(0, 0, 0, 0);
    const householdSize = Number(fields.householdSize);
    if (!Number.isFinite(moveInDate) || moveInDate < today.getTime()) throw new Error("Choose a move-in date from today onward.");
    if (!Number.isInteger(householdSize) || householdSize < 1 || householdSize > 30) throw new Error("Enter a household size between 1 and 30.");
    return { listingId, moveInDate, householdSize, employmentStatus: String(fields.employmentStatus || "").trim(), documentIds: [], note, saveAsDraft:fields.rentalDraft===true };
  }
  if (kind === "documents") {
    if (!note) throw new Error("Describe the documents you need.");
    return { category: "legal_support", listingId, location: listing.location || {}, budgetOMR: 0, preferredDate: 0, description: note };
  }
  throw new Error("This action is unavailable.");
}
